import { type ComponentType, use } from "react";

// Every page is drawn through here, and its module is the one the document it was served in names: a modulepreload
// the build wrote, marked and already fetched, so nothing in the shell's own bundle names a page and nothing has to
// be asked for before the import can start.
export function PageLoader() {
  const Page = use(loading);
  return <Page />;
}

// Started as this module loads rather than as React first renders, so the import is on its way before the shell is.
const loading = loadPage().catch((error: unknown) => {
  console.error(error);
  // Never settling, since React retries a rejection at once and no retry of this one would find another answer.
  return new Promise<ComponentType>(() => {});
});

async function loadPage(): Promise<ComponentType> {
  const link = document.querySelector<HTMLLinkElement>("link[rel=\"modulepreload\"][data-page]");
  if (!link) throw new Error("page-loader: the document names no page module");
  const page = await import(link.href) as { default: ComponentType };
  return page.default;
}
